import * as Sentry from '@sentry/react';
import PreviousHistoryTable from '@/components/PreviousHistoryTable';
import RightPanel from '@/components/portal/RightPanel';
import { useNote } from '@/context/NoteProvider';
import { useSimpleAudio } from '@/context/SimpleAudioProvider';
import { useAuth } from '@/hooks';
import { INoteHistory } from '@/interfaces/noteInterface';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import MobileNoteModal from './MobileNoteModal';
import { historyStyles } from './styles';

const History = () => {
  const { token } = useAuth();
  const noteContext = useNote();
  const { shouldRefreshHistory, setShouldRefreshHistory } = useSimpleAudio();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Auto-refresh history when coming from portal page with new notes
  useEffect(() => {
    if (shouldRefreshHistory && token) {
      noteContext.getHistory(1);
      setShouldRefreshHistory(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRefreshHistory, token, setShouldRefreshHistory]); // noteContext.getHistory is stable

  const handleNoteSelect = (note: INoteHistory, isUserClick = false) => {
    Sentry.startSpan(
      {
        op: 'ui.action',
        name: 'View History Note',
      },
      (span) => {
        span.setAttribute('caseid', note.caseid);
        span.setAttribute('is_user_click', isUserClick);
        span.setAttribute('is_mobile', isMobileOrTablet);
        
        noteContext.loadNote(note.caseid.toString());
        
        // Only open modal on mobile if it's a user click, not auto-selection
        if (isMobileOrTablet && isUserClick) {
          setIsModalOpen(true);
        }
      }
    );
  };

  return (
    <Box sx={historyStyles.contentWrapper}>
      <Box sx={historyStyles.leftPanel}>
        <PreviousHistoryTable onNoteSelect={handleNoteSelect} />
      </Box>

      <Box sx={historyStyles.rightPanel}>
        <RightPanel />
      </Box>

      {/* Mobile-only note modal */}
      <MobileNoteModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </Box>
  );
};

export default History;
